import React, {useState} from "react";
import './style.scss'
import {Modal} from "react-bootstrap";
import {DataChart, Notification, SystemChart} from "../index";
import {useDispatch, useSelector} from "react-redux";
import {showDataChart} from "../../redux/reducers/controllers";
import {selectController} from "../../redux/stores";
import ContentSelector from "../../redux/reducers/contents/action";

const Controller: React.FC = () => {

    const [showSystem, setShowSystem] = useState(false);

    const [showNotification, setShowNotification] = useState(false)

    const dispatch = useDispatch();

    const isShowDataChart = useSelector(selectController);

    const events = useSelector(ContentSelector.getEvents);

    return (
        <div className='controller d-flex flex-column'>
            <button className='controller-item'
                    onClick={() => {
                        setShowSystem(true);
                    }}
            >
                <i className='fa-solid fa-sitemap'></i>
            </button>
            <button className='controller-item'
                    onClick={() => {
                        dispatch(showDataChart(!isShowDataChart))
                    }}
            >
                <i className='fa-solid fa-chart-line'></i>
            </button>
            <button className='controller-item'
                    onClick={() => {
                        setShowNotification(!showNotification);
                    }}
            >
                <i className='fa-solid fa-bell'></i>
                <div className={(events.length > 0 ? 'has-event' : 'd-none')}></div>
            </button>
            <Modal
                show={showSystem}
                onHide={()  => {
                    setShowSystem(false)
                }}
                centered
                size='xl'
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Graph View
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <SystemChart/>
                </Modal.Body>
            </Modal>

            <DataChart/>
            <Notification isActive={showNotification} events={events}/>
        </div>
    )
}

export default Controller;
